const Loading = () => {
  return <span>[loading...]</span>;
};

export default Loading;
